import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

const PublicRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.accessToken;
  return (
    <Route
      {...rest}
      render={props => (token ? <Redirect to="/" /> : <Component {...props} />)}
    />
  );
};

PublicRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired
};

export default PublicRoute;
